(function ($, global) {

  /**
   * Вспомогательные функции реквизита "Выбор из справочника".
   * @since 5.5.0.1000
   */
  var ReferenceRecordSelectRequisite = global.BaseSelectRequisite.extend({
    className: 'ReferenceRecordSelectRequisite',

    /**
     * Загружает дополнительнные данные для ссылок. Например, наименование или ведущие реквизиты.
     *
     * @method _loadExtendedDataForLinks
     * @param {Array<WA.Link>} links Список ссылок.
     * @return {Deferred<Array<WA.Link>>} Список ссылок с загруженными дополнительными данными.
     * @private
     * @see https://api.jquery.com/category/deferred-object/
     */
    _loadExtendedDataForLinks: function (links) {
      //Надо переопределять в потомках.
      var d = $.Deferred();
      d.resolve(links.map(function (link) {
        link.name = '' + link.id;
        return link;
      }));
      return d.promise();
    },

    // Парсинг подходящей строки в ссылку.
    _parseSuitableUrl: function (url) {
      // Пример ссылки http://irwebaccess:83/reference.asp?sys=DIR55WebAccess&compcode=%ce%d0%c3&id=134049

      var idIndex = url.toLowerCase().indexOf('&id=');
      if (idIndex !== -1) {
        var idStr = url.substr(idIndex + 4); //+4 это пропуск "&id=", parseInt отбрасывает всё ненужно после первых цифр, поэтому нам не важно где кончается id. Например, parseInt('123&param=value') -> 123
        var id = parseInt(idStr, 10);
        //TODO
        var compcode = '';
        return new WA.Link(id, OBJECT_TYPE.REFERENCE_RECORD, compcode);
      }
      return null;
    }
  });

  global.ReferenceRecordSelectRequisite = ReferenceRecordSelectRequisite;

})(jQuery, window.Core.requisites);
